var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderFeedbackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header_feedback_icon_svg__clip0_21736_25991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 24c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 012.5 22c0-.55.195-1.021.588-1.412.393-.39.863-.587 1.412-.588h16c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412 0 .55-.196 1.02-.587 1.413-.39.393-.862.588-1.413.587h-16zm2-8h1.4l7.8-7.775-.725-.725-.7-.7L6.5 14.6V16zm-2 1v-2.825a1.03 1.03 0 01.3-.725L15.7 2.575A1.976 1.976 0 0117.1 2c.266 0 .524.05.775.15.25.1.476.25.675.45L19.925 4c.2.183.346.4.437.65.091.25.137.508.138.775 0 .25-.046.496-.138.738a1.875 1.875 0 01-.437.662L9.05 17.7a1 1 0 01-.725.3H5.5a.965.965 0 01-.712-.288A.972.972 0 014.5 17zm11.2-8.775l-.725-.725-.7-.7L15.7 8.225z",
    fill: "#CDCDCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "header_feedback_icon_svg__clip0_21736_25991"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgHeaderFeedbackIcon;